import React, { useEffect, useState } from "react";
import { Col, Input, Row, Form, Select, message } from "antd";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createTenant,
  setTenantDetailsIsEdit,
  updateTenant,
} from "../redux/actions";
import SpinnerComponent from "../../../components/spinner";
import { useLocation } from "react-router-dom";
import { tenantNameRegex } from "../../../globalUtils/tenant";
import { tenantSourceOptions } from "../utils";
import { baseURL } from "../../../globalUtils/axiosConfig";
// import sampleImg from '../../../assets/user-icon.svg';
import sampleImg from "../../../assets/logo.png";

const TenantDetailsSection = ({ isTenantUpdate, canUpdate }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [sourcesSelected, setSourcesSelected] = useState([]);
  // const [tenantType, setTenantType] = useState("private");
  const [userProfileImg, setUserProfileImg] = useState(null);
  const [isUserImgSelected, setIsUserImgSelected] = useState(false);
  const [loading, setLoading] = useState(false);

  const [currentTenant, setCurrentTenant] = useState({
    name: "",
    sources: [],
    type:"",
  });

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [form] = Form.useForm();

  const { Option } = Select;

  const { createTenantLoading, currentTenantObj, tenantDetailsIsEdit } =
    useSelector((state) => state.tenantsReducer);

  useEffect(() => {
    if (currentTenantObj?._id) {
      setCurrentTenant(currentTenantObj);
      const { name, type } = currentTenantObj;
      const prevSources = currentTenantObj?.config?.login?.sources || [];

      form.setFieldsValue({ name, type });
      setSourcesSelected(prevSources);
      setCurrentTenant(type);
    }
  }, [currentTenantObj]);

  useEffect(() => {
    if (pathname.includes("create") && currentTenantObj?._id === undefined) {
      setIsEdit(true);
    } else {
      setIsEdit(tenantDetailsIsEdit);
    }
  }, [tenantDetailsIsEdit, currentTenantObj]);

  const onFinish = (values) => {
    const { ...res } = values;

    // if ((!userProfileImg || userProfileImg?.length < 1) && !isTenantUpdate) {
    //   return message.error('Institute logo is required!');
    // }

    if (sourcesSelected.length < 1) {
      return message.error("Please select login options!");
    }

    isTenantUpdate
      ? dispatch(
          updateTenant({
            ...res,
            sources: sourcesSelected,
            // type: tenantType,
            id: currentTenantObj._id,
            ...(userProfileImg && { logo_path: userProfileImg }),
          })
        )
      : dispatch(
          createTenant({
            ...res,
            sources: sourcesSelected,
            // type: tenantType,
            ...(userProfileImg && { logo_path: userProfileImg }),
          })
        );
  };

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const handleSave = () => {
    form.submit();
  };

  const changeHandler = (event) => {
    const image = event.target.files[0];
    if (!image) {
      return false;
    }
    if (!image.name.match(/\.(png)$/)) {
      message.error("Logo should be png format.");
      return false;
    }
    if (image.size > 2097152) {
      message.error("Logo size should not greater than 2MB.");
      return false;
    }
    setUserProfileImg(event.target.files[0]);
    // handleChange("image", event.target.files[0]);
    setIsUserImgSelected(true);
  };

  return (
    <>
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span">Institute Details</span>
              </div>
            </Col>
            <Col>
              {isEdit ? (
                createTenantLoading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon width={16} height={16} onClick={handleSave} />
                )
              ) : (
                canUpdate && (
                  <EditIcon
                    width={16}
                    fill="#e21c21"
                    height={16}
                    onClick={() => dispatch(setTenantDetailsIsEdit(true))}
                  />
                )
              )}
            </Col>
          </Row>
        </Col>
        <Col
          span={24}
          className={`user-details-section project-details-section ${
            !isEdit && "is-edit"
          }`}
        >
          <Row justify="start">
            <Col md={5} lg={5} xl={5} xxl={4} className="photo-col">
              <div>
                <span>LOGO</span>
                <div className={`img-parent-div ${isEdit && "edit-image"}`}>
                  <div className="img-nested-div">
                    <img
                      width="100%"
                      height="100%"
                      src={
                        isUserImgSelected
                          ? URL.createObjectURL(userProfileImg)
                          : currentTenantObj?.logo_path
                          ? `${baseURL}/${currentTenantObj?.logo_path}`
                          : sampleImg
                      }
                      alt="user-profile"
                    />
                  </div>
                  {isEdit && (
                    <div className="edit-icon-div">
                      <input
                        readOnly={createTenantLoading}
                        disabled={!isEdit}
                        type="file"
                        name="institute_logo"
                        id="institute_logo"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={changeHandler}
                      />
                      <label htmlFor="institute_logo">
                        <EditIcon height={14} width={14} />
                      </label>
                    </div>
                  )}
                </div>
                {isEdit && (
                  <div className="text-div">
                    <span className="text">
                      Upload a PNG file.
                      <br />
                      Recommended logo size 512 x 512: Max 2 MB{" "}
                    </span>
                  </div>
                )}
              </div>
            </Col>
            <Col md={24} lg={23} xl={20} xxl={20}>
              <Form
                {...formItemLayout}
                form={form}
                name="user-details"
                onFinish={onFinish}
                initialValues={currentTenant}
                scrollToFirstError
                labelWrap={true}
                layout="horizontal"
                className="user-detail-form"
                requiredMark={false}
              >
                <Row gutter={[20, 10]}>
                  <Col span={12}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        // {
                        //   pattern: tenantNameRegex,
                        //   message: "Invalid Name",
                        // },
                      ]}
                      name="name"
                      label="Name *"
                    >
                      <Input
                        readOnly={createTenantLoading || isTenantUpdate}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Institute Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Login Options">
                      <Select
                        mode="multiple"
                        size="middle"
                        style={{
                          width: "100%",
                        }}
                        disabled={!isEdit}
                        placeholder={`${!isEdit ? "" : "Select Login Options"}`}
                        value={sourcesSelected}
                        onChange={(e) => setSourcesSelected(e)}
                        options={tenantSourceOptions}
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="type"
                      label="Type"
                      initialValue="private"
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                    >
                      <Select
                        size="small"
                        dropdownClassName="select-dropdown-custom"
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        showSearch
                        placeholder="Select Type"
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        optionFilterProp="children"
                        optionLabelProp="label"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {[
                          { label: "PUBLIC", value: "public" },
                          { label: "PRIVATE", value: "private" },
                        ]?.map(({ label, value }) => {
                          return (
                            <Option value={value} label={label}>
                              {label || ""}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[0, 10]}>
                      {/* <Col span={12}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: 'Required!',
                            },
                          ]}
                          name='sources'
                          label='Source Type *'
                        >
                          <Select
                            style={{
                              width: '100%',
                            }}
                            disabled={!isEdit || !canUpdate}
                            readOnly={true}
                            className='department-select'
                            dropdownClassName='select-dropdown-custom'
                            getPopupContainer={() =>
                              document.getElementsByClassName(
                                'ant-layout-content layout-content site-layout-background custom-textarea'
                              )[0]
                            }
                            showSearch
                            placeholder='Select Type'
                            optionFilterProp='children'
                            // onChange={onChange}
                            // onSearch={onSearch}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {tenantSourceOptions.map(({ label, key }) => {
                              return (
                                <Option key={key} value={key}>
                                  {label}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </Col> */}
                      {/* <Col span={24}>
                        {source === 'file' && (
                          <AttachmentsSection
                            isEdit={isEdit}
                            loading={createTenantLoading}
                            documents={documents}
                            setDocuments={setDocuments}
                            currentTenant={currentTenant}
                          />
                        )}
                        {source === 'remote' && (
                          <Col span={20}>
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: 'Required!',
                                },
                                {
                                  pattern: pathRegex,
                                  message: 'Invalid URL',
                                },
                              ]}
                              name='url'
                              label='Remote URL *'
                            >
                              {isEdit ? (
                                <Input
                                  readOnly={createTenantLoading}
                                  disabled={!isEdit || !canUpdate}
                                  placeholder='Enter Remote URL'
                                />
                              ) : (
                                <>
                                  <div
                                    style={{
                                      paddingLeft: '10px',
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      let url = form.getFieldValue('url');
                                      if (url) {
                                        window.open(url, '_blank');
                                      }
                                    }}
                                  >
                                    {form.getFieldValue('url')}
                                  </div>
                                </>
                              )}
                            </Form.Item>
                          </Col>
                        )}
                      </Col> */}
                    </Row>
                  </Col>
                  {/* <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                      name='status_id'
                      label='NPO Status'
                    >
                      <Select
                        style={{
                          width: '100%',
                        }}
                        disabled={!isEdit || !canUpdate}
                        readOnly={true}
                        className='department-select'
                        dropdownClassName='select-dropdown-custom'
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            'ant-layout-content layout-content site-layout-background custom-textarea'
                          )[0]
                        }
                        showSearch
                        placeholder='Select NPO Status'
                        optionFilterProp='children'
                        onChange={onChange}
                        // onSearch={onSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {allTenantStatuses.map(({ id, name }) => {
                          return (
                            <Option key={id} value={id}>
                              {name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                      name='contact_name'
                      label='Director Name'
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={
                          !isEdit ||
                          // isTenantUpdate ||
                          !canUpdate
                        }
                        placeholder='Director Name'
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      name='contact_no'
                      label='Director Contact Number'
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={!isEdit} // || isTenantUpdate
                        placeholder='Director Contact Number'
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      name='email'
                      label='Director Email'
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid Email!',
                        },
                      ]}
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={!isEdit || !canUpdate} // || isUserUpdate
                        placeholder='Director Email'
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                      name='manager_name'
                      label='PROGRAMME MANAGER NAME'
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={
                          !isEdit ||
                          // isTenantUpdate ||
                          !canUpdate
                        }
                        placeholder='Programme Manager Name'
                      />
                    </Form.Item>
                  </Col>

                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      name='manager_no'
                      label='PROGRAMME MANAGER NUMBER'
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={!isEdit} // || isTenantUpdate
                        placeholder='Programme Manager Number'
                      />
                    </Form.Item>
                  </Col>
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      name='manager_email'
                      label='PROGRAMME MANAGER EMAIL'
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid Email!',
                        },
                      ]}
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={!isEdit || !canUpdate} // || isUserUpdate
                        placeholder='Programme Manager Email'
                      />
                    </Form.Item>
                  </Col> */}
                  {/* <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                      name='project_type'
                      label='Type of NPO'
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={!isEdit || !canUpdate}
                        placeholder='Type of NPO'
                      />
                    </Form.Item>
                  </Col> */}

                  {/* <Col md={8} lg={8} xl={8} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                      name='onboard_date'
                      label='NPO Onboard Date'
                    >
                      <DatePicker
                        style={{
                          width: '100%',
                        }}
                        format='D-MM-YYYY'
                        allowClear={false}
                        suffixIcon={null}
                        placeholder='NPO Onboard Date'
                        disabled={!isEdit || !canUpdate || loading}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={16} lg={16} xl={16} xxl={16}>
                    <Form.Item
                      name='address'
                      label='NPO Address'
                      rules={[
                        {
                          required: true,
                          message: 'Required!',
                        },
                      ]}
                    >
                      <Input
                        readOnly={createTenantLoading}
                        disabled={!isEdit} // || isTenantUpdate
                        placeholder='NPO Address'
                      />
                    </Form.Item>
                  </Col> */}
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="empty-div"></div>
    </>
  );
};

export default TenantDetailsSection;
